import angular from 'angular';

import BaseController from './audit-trail.base.controller';

export default function AuditTrailController(
  $filter,
  $location,
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  editAuditDialog,
  loaderService,
  orgDataService,
  serviceIds,
  amSettingsDialog,
  ssDialogService,
  userService
) {
  BaseController.call(this, userService, loaderService);
  this.initPermissions();
  const vm = this;

  vm.eulaAccepted = true;
  vm.appIsLoaded = false;
  vm.customerId = 0;
  vm.serviceId = serviceIds.AM;
  vm.groupId = 16;

  vm.activeAuditsHaveDeletedAgency = false;

  vm.filters = _getDefaultFilters();

  vm.handleShowSettings = handleShowSettings;
  vm.handleShowAddAudit = handleShowAddAudit;
  vm.handleFilterChange = _handleFilterChange;

  _activate();

  /** ***************************************************
   * Event Handlers
   */

  function handleShowSettings($event) {
    loaderService.showViewLoader = true;
    return amDataService.getSettings().then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.auditTrail.settingsDialog = ssDialogService.alert(
        amSettingsDialog.getOptions($event, {
          settings: response.data,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.auditTrail.settingsDialog);
    });
  }

  function handleShowAddAudit($event) {
    loaderService.showViewLoader = true;
    return _refreshAgencies().then(() => _refreshUsers().then(() => amDataService.getDataTypes().then((response) => {
      loaderService.showViewLoader = false;
      // Display new audit dialog
      ssDialogService.dialogs.auditTrail.editAuditDialog = ssDialogService.alert(
        editAuditDialog.getOptions($event, {
          audit: {
            auditId: 0,
            auditTypeId: 1,
            agencyisThirdParty: false,
            isActive: true,
            startDate: null,
            preparationItemsDefaultDueDate: null,
            findingsDefaultDueDate: null,
            onsiteDate: null,
            findingRemediationStartDate: null,
          },
          agencies: vm.agencies,
          auditTypes: vm.auditTypes,
          coordinators: vm.coordinators,
          dataTypes: response.data.result,
          refreshAudit: false,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.auditTrail.editAuditDialog);
    })));
  }

  function _handleFilterChange() {
    _applyFilters();
  }

  /** ***************************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initDocumentManagement();

    userService.getUser(false).then((user) => {
      vm.customerId = user.customerId;
    });

    _initPage().then(() => {
      vm.eulaAccepted = true;
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
    });
  }
  /*
  function _verifyServiceAcceptance() {
    return $q.all([
      orgDataService.getCSAText(serviceIds.AM),
      userService.getUser()
    ]).then((results) => {
      const eula = results[0].data.result[0];
      const user = results[1];
      return orgDataService.getEULAServiceAcceptanceByCustomer(user.customerId, eula.serviceEulaId)
        .then((acceptanceResponse) => {
          const requiresServiceAcceptance = !!eula;
          const hasServiceAcceptance = (acceptanceResponse.data.recordCount > 0);

          if (!hasServiceAcceptance && requiresServiceAcceptance) {
            return _showCustomerServiceAcceptance();
          }

          vm.eulaAccepted = true;
          return _initPage();
        });
    });
  }
  */
  // eslint-disable-next-line
  function _initPage() {
    return amDataService.initAuditTrail().then((getAuditTrailInitResponse) => {
      // _refreshAgencies(),
      if (getAuditTrailInitResponse.data.Agencies) {
        vm.agencies = getAuditTrailInitResponse.data.Agencies.result;
        amSharedModelService.agencies = vm.agencies;
      }
      // _refreshBusinessRisks(),
      if (getAuditTrailInitResponse.data.BusinessRisks) {
        vm.businessRisks = getAuditTrailInitResponse.data.BusinessRisks;
        amSharedModelService.businessRisks = vm.businessRisks;
      }
      // _refreshTechnicalRisks(),
      if (getAuditTrailInitResponse.data.TechnicalRisks) {
        vm.technicalRisks = getAuditTrailInitResponse.data.TechnicalRisks.result;
        amSharedModelService.technicalRisks = vm.technicalRisks;
      }
      // _refreshPriorities(),
      if (getAuditTrailInitResponse.data.Priorities) {
        vm.priorities = getAuditTrailInitResponse.data.Priorities.result;
        amSharedModelService.priorities = vm.priorities;
      }
      // _refreshFindingStatuses(),
      if (getAuditTrailInitResponse.data.FindingStatuses) {
        vm.findingStatuses = getAuditTrailInitResponse.data.FindingStatuses.result;
        amSharedModelService.findingStatuses = vm.findingStatuses;
      }
      // _refreshPreparationItemStatuses(),
      if (getAuditTrailInitResponse.data.PreparationItemStatuses) {
        vm.preparationItemStatuses = getAuditTrailInitResponse.data.PreparationItemStatuses.result;
        amSharedModelService.preparationItemStatuses = vm.preparationItemStatuses;
      }
      // _refreshRecommendationStatuses(),
      if (getAuditTrailInitResponse.data.RecommendationStatuses) {
        vm.recommendationStatuses = getAuditTrailInitResponse.data.RecommendationStatuses.result;
        amSharedModelService.recommendationStatuses = vm.recommendationStatuses;
      }
      // _refreshUsers(),
      if (getAuditTrailInitResponse.data.Coordinators) {
        vm.coordinators = getAuditTrailInitResponse.data.Coordinators.result;
        amSharedModelService.applicationUsers = vm.coordinators;
      }

      if (getAuditTrailInitResponse.data.ApplicationUsers) {
        vm.applicationUsers = getAuditTrailInitResponse.data.ApplicationUsers.result;
        amSharedModelService.applicationUsers = vm.applicationUsers;
      }

      // _refreshAudits(),
      if (getAuditTrailInitResponse.data.Audits) {
        vm.audits = getAuditTrailInitResponse.data.Audits.result;
        _applyFilters();
      }

      // _refreshAuditFields(),
      if (getAuditTrailInitResponse.data.AuditFields) {
        amSharedModelService.auditFields = getAuditTrailInitResponse.data.AuditFields.result;
      }
      // _refreshAuditTypes(),
      if (getAuditTrailInitResponse.data.AuditTypes) {
        vm.auditTypes = getAuditTrailInitResponse.data.AuditTypes.result;
        amSharedModelService.auditTypes = vm.auditTypes;
      }
    });
  }

  function _applyFilters() {
    if ((vm.filters.searchText === null) || (vm.filters.searchText === '')) {
      vm.filteredAudits = vm.audits;
    } else {
      vm.filteredAudits = $filter('filter')(vm.audits, { name: vm.filters.searchText });
    }

    vm.hasAudits = vm.audits.length > 0;
    vm.allAuditsFiltered = vm.filteredAudits.length === 0;

    vm.activeAudits = $filter('filter')(vm.filteredAudits, { isActive: true });

    // Set the Agency (if the agency is a deleted vendor)
    vm.activeAuditsHaveDeletedAgency = false;
    angular.forEach(vm.activeAudits, (item) => {
      if ((item.agency != null) && (!item.agency.isActive)) {
        vm.activeAuditsHaveDeletedAgency = true;
      }
    });

    vm.allActiveAuditsFiltered = vm.activeAudits.length === 0;

    vm.completedAudits = $filter('filter')(vm.filteredAudits, { isActive: false });
    vm.allCompletedAuditsFiltered = vm.completedAudits.length === 0;

    $rootScope.latestCompletedAudit = $filter('orderBy')(vm.completedAudits, 'name', true)[0];
  }

  /*
  function _respondToCancelCustomerServiceAcceptance() {
    alerts.warning('In order to use Audit-Trail, EULA acceptance is required.');
    $location.path('/');
  }

  function _showCustomerServiceAcceptance() {
    return customerServiceAcceptanceDialog.show(
      serviceIds.AM,
      _customerAcceptedServiceAgreement,
      _respondToCancelCustomerServiceAcceptance
    );
  }

  function _customerAcceptedServiceAgreement() {
    loaderService.showViewLoader = true;
    return _verifyServiceAcceptance().then(() => {
      loaderService.showViewLoader = false;
      vm.appIsLoaded = true;
    });
  }
  */
  function _initEventListeners() {
    $scope.$on('refreshAMAudits', _refreshAudits);
    $scope.$on('refreshAMAgencies', _refreshAgencies);
    $scope.$on('refreshAMAuditUsers', _refreshUsers);
    $scope.$on('refreshAMFieldNameDefaults', _refreshFieldNameDefaults);
    $scope.$on('refreshAMAuditFields', _refreshAuditFields);
    $scope.$on('refreshAMTechnicalRisks', _refreshTechnicalRisks);
    $scope.$on('refreshAMBusinessRisks', _refreshBusinessRisks);
    $scope.$on('refreshAMPriorities', _refreshPriorities);
    $scope.$on('refreshAMAuditTypes', _refreshAuditTypes);
  }

  function _initDocumentManagement() {
    vm.maxAttachments = 10; // TODO: set maxAttachments to business specs (10 is just a guess) or to value from api
  }

  function _refreshAudits() {
    return amDataService.getAudits().then((getAuditsResponse) => {
      vm.audits = getAuditsResponse.data.result;

      vm.activeAudits = $filter('filter')(vm.audits, { isActive: true });

      // Set the Agency (if the agency is a deleted vendor)
      vm.activeAuditsHaveDeletedAgency = false;
      angular.forEach(vm.activeAudits, (item) => {
        if ((item.agency != null) && (!item.agency.isActive)) {
          vm.activeAuditsHaveDeletedAgency = true;
        }
      });

      vm.completedAudits = $filter('filter')(vm.audits, { isActive: false });
      $rootScope.latestCompletedAudit = $filter('orderBy')(vm.completedAudits, 'name', true)[0];

      _applyFilters();
    });
  }

  function _refreshAuditFields() {
    return amDataService.getCustomerAuditFields().then((getCustomerAuditFieldsResponse) => {
      amSharedModelService.auditFields = getCustomerAuditFieldsResponse.data.result;
    });
  }

  function _refreshFieldNameDefaults() {
    return amDataService.getFieldNameDefaults().then((response) => {
      vm.fieldNameDefaults = response.data.response;
    });
  }

  function _refreshAgencies() {
    return amDataService.getAgencies().then((response) => {
      vm.agencies = response.data.result;
      amSharedModelService.agencies = vm.agencies;
    });
  }

  function _refreshBusinessRisks() {
    return amSharedModelService.getBusinessRisks().then((businessRisks) => {
      vm.businessRisks = businessRisks;
    });
  }

  function _refreshTechnicalRisks() {
    return amDataService.getTechnicalRisks().then((response) => {
      vm.technicalRisks = response.data.result;
      amSharedModelService.technicalRisks = vm.technicalRisks;
    });
  }

  function _refreshPriorities() {
    return amDataService.getPriorities().then((response) => {
      vm.priorities = response.data.result;
      amSharedModelService.priorities = vm.priorities;
    });
  }

  // eslint-disable-next-line
  function _refreshFindingStatuses() {
    return amDataService.getFindingStatuses().then((response) => {
      vm.findingStatuses = response.data.result;
      amSharedModelService.findingStatuses = vm.findingStatuses;
    });
  }

  // eslint-disable-next-line
  function _refreshPreparationItemStatuses() {
    return amDataService.getPreparationItemStatuses().then((response) => {
      vm.preparationItemStatuses = response.data.result;
      amSharedModelService.preparationItemStatuses = vm.preparationItemStatuses;
    });
  }

  function _refreshUsers() {
    return orgDataService.getApplicationUsers().then((appUserResponse) => {
      vm.coordinators = appUserResponse.data.result;
      amSharedModelService.coordinators = vm.coordinators;

      orgDataService.getSelectableUsers().then((aissgnableUserResponse) => {
        vm.applicationUsers = aissgnableUserResponse.data.result;
        amSharedModelService.applicationUsers = vm.applicationUsers;
      });
    });
  }

  function _refreshAuditTypes() {
    return amDataService.getAuditTypes().then((response) => {
      vm.auditTypes = response.data.result;
      amSharedModelService.auditTypes = vm.auditTypes;
    });
  }

  function _getDefaultFilters() {
    return {
      searchText: '',
    };
  }
}

AuditTrailController.$inject = [
  '$filter',
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'editAuditDialog',
  'loaderService',
  'orgDataService',
  'serviceIds',
  'amSettingsDialog',
  'ssDialogService',
  'userService',
];
